import React from 'react';
import { default as ReactSelect } from 'react-select';
import { components } from 'react-select';

function SummaryCallType({setCallType}) {
    // {selectedPriority, setSelectedPriority}
  const Option = props => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{' '}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const optionList = [
    { value: "Week #1", label: "Week #1"},
    { value: "Week #3", label: "Week #3" },
    { value: "Prescription Call", label: "Prescription Call" },
    { value: "retention", label: "retention"},
    { value: "SLOT_BOOKING", label: "SLOT_BOOKING" },
    { value: "IVR Booking", label: "IVR Booking" },
    { value: "Feedback Call", label: "Feedback Call"},
    { value: "ADHOC_CALL", label: "ADHOC_CALL"},
    { value:  "Concern Call", label:  "Concern Call" },
  ];

  function handleSelect(data) {
    setCallType(data);
  }
  return (
    <>
      <span
        className="d-inline-block"
        data-toggle="popover"
        data-trigger="focus"
        data-content="Please select Priority"
      >
        <ReactSelect
          options={optionList}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          components={{
            Option
          }}
          onChange={handleSelect}
          allowSelectAll={true}
          placeholder="Select Call Type"
          styles={{ control: (base) => ({ ...base, width: '16rem', maxHeight:"5rem" ,overflowY:"scroll"}) }}
        //   value={selectedPriority}
        />
      </span>
    </>
  );
}

export default SummaryCallType;
